export default "__VITE_ASSET__BpjtFIi9__"